export const loginInitialValues = {
    email : '',
    password: ''
}

export const registerInitialValues = {
    name:'',
    email : '',
    password: '',
    confirmPassword:'',
    isBlocked:''
}

export const profileInitialValues = {
    oldPassword : '',
    newPassword: '',
    confirmPassword:''
}

export const areaInitialValues = {
    areaName:'',
}

export const placeInitialValues = {
    placeName:'',
    slotsQty: ''
}


